export const setLocalStorage = (cname, cvalue, exdays) => {
    localStorage.setItem(cname, cvalue);
};

export const getLocalStorage = (cname) => localStorage.getItem(cname) || "";

export const init = () => {
    if (!getLocalStorage("SUB_DIR_INDEX")) {
        setLocalStorage("SUB_DIR_INDEX", 0);
        // console.log("DEBUG in init():  Unable to get SUB_DIR_INDEX cookie, defaulting it to 0");
    }
    else {
        // console.log(`DEBUG in init():  Successfully obtained SUB_DIR_INDEX cookie and it is ${getLocalStorage("SUB_DIR_INDEX")}`);
    }
};

export const readCookie = (name) => {
    var c = document.cookie.split('; '),
    cookies = {}, i, C;

    for (i = c.length - 1; i >= 0; i--) {
        C = c[i].split('=');
        cookies[C[0]] = C[1];
     }

     return cookies[name];
};

export const findCurrentLang = (str) => {
	// console.log(`DEBUG:  Utils - findCurrentLang - ${str}`);
    const regex = /\/auto\/([a-zA-Z-]+)/;
    const found = str?.match(regex);
	// console.log(`DEBUG:  Utils - found - ${JSON.stringify(found)}`);
    return found?.length ? found[1] : null;
};

export const filterStories = (storiesBase, lookupTags) => {
	const lookupValue = (lookup, str) => new RegExp("\\b" + lookup + "\\b").test(str);
	if (lookupTags) {
		return storiesBase.filter(e => {
			const input = e.title.toLowerCase();
			return lookupTags.map(e => {
				const res = e.map(e => 
					// Match whole word 'e' in 'input'
					lookupValue(e, input)
					// Match just the string 'e' in 'input'
					// input.includes(e)
				);
				return !res.includes(false);  // AND them all together
			}).includes(true);  // OR them all together
		});
	}
	else {
		return storiesBase;
	}
};

export const getDataWithFetch = async(url, authToken) => {
	try {
		let formData = {
			method: "GET",
		};
	
		if (authToken) {
			formData['headers'] = {
				'Authorization': `Bearer ${authToken}`,
				'Content-Type': 'application/json',
			};
			// formData['mode'] = 'cors'  // Ensure CORS is set
		}

		// console.log('DEBUG', url, formData);
		// console.log(`DEBUG in postDataWithFetch(): url - ${url}`);
		// console.log(`DEBUG in postDataWithFetch(): formData - ${JSON.stringify(formData)}`);
		let res = await fetch(url, formData);
	
		if (res?.ok && res?.status === 200) {
			let resJson = await res.json();
			return resJson;
		}
		else {
			// console.log(`DEBUG:  Utils - url = ${url} status = ${res?.status}`);
			return false;
		}		
	}
	catch (error) {
		console.error('Fetch error:', error);
	}
};

export const postDataWithFetch = async(url, parms) => {
	const data = new URLSearchParams();
	
	const entries = Object.entries(parms)
	entries.forEach(entry => {
		if ( entry.length === 2 ) {
			data.append(...entry);
		}
	});

	let formData = {
		method: "POST",
		body: data,
	};

	// console.log(`DEBUG in postDataWithFetch(): url - ${url}`);
	// console.log(`DEBUG in postDataWithFetch(): formData - `, formData);
	let res = await fetch(url, formData);
	let resJson = await res.json();
	return resJson;
};

export const clone = (obj) => {
	let newObject = JSON.parse(JSON.stringify(obj));
	// let newObject = Object.create(objs);
	return newObject;
};

export const getTagLabelInfo = async(BASE_URL, lang) => {
	const url = `${BASE_URL}index.php/misc/get_region_titles/${lang}`;
	// console.log(`DEBUG before get_region_titles:  ${url}`);
	const response = await fetch(url);
	const json = await response.json();
	// console.log('DEBUG:', json);
	return json;
};

export const getIpInfo = async(BASE_URL) => {
	const ip_info_url = 'http://ipinfo.io/json?token=aaa4d2dcfad56d';
	// const ip_info_url = 'https://ipinfo.io/json?token=aaa4d2dcfad56d';
	// const ip_info_url = 'http://ipinfo.io/json';
	// console.log('DEBUG:  App - ', ip_info_url);
	let requestOptions = {
		method: 'GET',
	};
	// console.log('DEBUG:  App - ', JSON.stringify(requestOptions));
	let json = getDataWithFetch(ip_info_url);
	// console.log('DEBUG:  App - ', JSON.stringify(json));
	if (json) {
		const parms = {
			CITY: (json.city ? json.city : 'NULL'),
			COUNTRY: (json.country ? json.country : 'NULL'),
			HOST_NAME: (json.hostname ? json.hostname : 'NULL'),
			IP: (json.ip ? json.ip : 'NULL'),
			LOC: (json.loc ? json.loc : 'NULL'),
			ORG: (json.org ? json.org : 'NULL'),
			POSTAL: (json.postal ? json.postal : 'NULL'),
			REGION: (json.region ? json.region : 'NULL')
		};
		// console.log('DEBUG:  App - ', JSON.stringify(requestOptions));
		const upsert_ip_info = `${BASE_URL}index.php/ip_info/upsert`;
		postDataWithFetch(upsert_ip_info, parms);
		// console.log('DEBUG:  App - ', upsert_ip_info);
		let response = await fetch(upsert_ip_info, requestOptions);
		json = await response.json();
		// console.log('DEBUG:  App - ', JSON.stringify(json));
		return json;
	}

	return null;
};

export const deepEqual = (obj1, obj2) => {
	// Check if both values are strictly equal (handles primitives and identical references)
	if (obj1 === obj2) return true;
	
	// Check if both are objects (but not null) and have the same type
	if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
		return false;
	}
	
	// Get object keys and check if they have the same length
	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);
	
	if (keys1.length !== keys2.length) return false;
	
	// Recursively compare the values of each key in both objects
	for (let key of keys1) {
		if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
			return false;
		}
	}
	
	return true;
};

export const isValidString = str => typeof str === 'string' && str.trim() !== '';
